
export const cellSx = {  };
export const labelCellSx = { pl: 0 };
export const valueSx = { width: 100, justifyContent: "center", px: 1 };